<div id="addr-ac-opts" [style.--parent-width]="parentWidth">
  <div>
    <datalist>
      <option *ngFor="let p of predictions" (click)="selectAddr(p)">{{p.description}}</option>
    </datalist>
  </div>
</div>